import { Block } from '@comp/crRender'
import './style.css'
import ContactInfo from './components/ContactInfo'
import ProviderDocs from './components/ProviderDocs'
import ProviderCard from './components/ProviderCard'

const Details = ({ requestDetails }) => {

    const documents = requestDetails?.documents || [
        { name: "Hospital-License.pdf", status: "approved" },
        { name: "Commercial-Registration.pdf", status: "approved" },
        { name: "Tax-Card.pdf", status: "pending" },
        { name: "JCI-Certificate.pdf", status: "pending" },
        { name: "GAHAR-Certificate.pdf", status: "pending" },
    ]

    return (
        <Block isRender={!!requestDetails} className="provider-rr-container">
            <div className="provider-rr-grid">
                <ProviderCard requestDetails={requestDetails} />
                <ContactInfo requestDetails={requestDetails} />
            </div>

            <ProviderDocs documents={documents} />
        </Block>
    )
}

export default Details
